import { Navigate, RouterProvider, createBrowserRouter, type RouteObject } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "@shared/auth/AuthContext";
import { RequireAdmin } from "@shared/auth/RequireAdmin";
import { Layout } from "@shared/components/Layout";
import { LoginPage } from "@features/auth/LoginPage";
import { ArticleEditorPage } from "@features/articles/ArticleEditorPage";
import { ArticleListPage } from "@features/articles/ArticleListPage";
import { IntroEditorPage } from "@features/intros/IntroEditorPage";
import { IntroListPage } from "@features/intros/IntroListPage";
import { BaziCalculatorPage } from "@features/bazi/BaziCalculatorPage";

// A data router (not <BrowserRouter>) because the editor warns before leaving unsaved work (useBlocker).
export const appRoutes: RouteObject[] = [
  { path: "/login", element: <LoginPage /> },
  // Public on purpose: the BaZi calculator needs no sign-in, so it sits outside RequireAdmin.
  { path: "/bazi", element: <BaziCalculatorPage /> },
  {
    element: <RequireAdmin />,
    children: [
      {
        element: <Layout />,
        children: [
          { path: "/articles", element: <ArticleListPage /> },
          { path: "/articles/new", element: <ArticleEditorPage /> },
          { path: "/articles/:id", element: <ArticleEditorPage /> },
          { path: "/intros", element: <IntroListPage /> },
          { path: "/intros/:code", element: <IntroEditorPage /> },
          { path: "*", element: <Navigate to="/articles" replace /> },
        ],
      },
    ],
  },
];

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={createBrowserRouter(appRoutes)} />
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
